export type TrelloCallbackPayload = {
  error?: string;
  state?: string;
  token?: string;
};

function readTrimmedParam(
  params: URLSearchParams,
  key: string,
): string | undefined {
  const value = params.get(key)?.trim();
  return value ? value : undefined;
}

export function parseTrelloCallbackPayload(
  search: string,
  hash: string,
): TrelloCallbackPayload {
  const searchParams = new URLSearchParams(search);
  const hashParams = new URLSearchParams(
    hash.startsWith('#') ? hash.slice(1) : hash,
  );

  return {
    error: readTrimmedParam(hashParams, 'error'),
    state: readTrimmedParam(searchParams, 'state'),
    token: readTrimmedParam(hashParams, 'token'),
  };
}

export function buildSettingsOAuthRedirect(params: {
  oauth?: string;
  oauthError?: string;
}): string {
  const next = new URLSearchParams();
  if (params.oauth) {
    next.set('oauth', params.oauth);
  }

  if (params.oauthError) {
    next.set('oauth_error', params.oauthError);
  }

  const query = next.toString();
  return query.length > 0 ? `/settings?${query}` : '/settings';
}
